import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-assignment-arena',
  templateUrl: './assignment-arena.component.html',
  styleUrls: ['./assignment-arena.component.scss']
})
export class AssignmentArenaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
